export function canSubmitBooking({
  appointmentReason,
  useInsurance,
  planId,
  planTypeId,
  memberId,
  acceptingInsurance,
  selfPayPricingAvailable,
}) {
  if (!appointmentReason?.trim()) return false;
  if (typeof acceptingInsurance !== "boolean") return false;
  if (!useInsurance) {
    return acceptingInsurance || selfPayPricingAvailable;
  }

  if (!acceptingInsurance) return false;

  return Boolean(planId && planTypeId && memberId?.trim());
}
